export default __webpack_public_path__ + "static/media/git.057f1187.svg";